export const common = {
  welcome: "Welcome",
  home: "Home",
  about: "About",
  contact: "Contact",
  services: "Services",
  products: "Products",
  learnMore: "Learn More",
  getStarted: "Get Started",
  submit: "Submit",
  cancel: "Cancel",
  close: "Close",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  search: "Search",
  loading: "Loading...",
  error: "An error occurred",
  success: "Success",
  reserveNow: 'Reserve Now',
};